import templateUrl from "emun.order/parts/parts-order-list-grid.htm";
export default () => ({ templateUrl });
